import { XStack, YStack } from '@/components/ui/layout/layout';

import { PersonAvatar } from './person-avatar';
import { TeamLabel } from './team-label';

import type { WikiPerson } from '../people-wiki.types';

export const PersonCell = ({
  person,
  email = person.primaryEmail,
}: {
  person: WikiPerson;
  /** The address on the second line, the primary one unless the line is about another */
  email?: string | null;
}) => (
  <XStack className="min-w-0 items-center gap-3">
    <PersonAvatar person={person} sizeClassName="size-8" />
    <YStack className="min-w-0 gap-0.5">
      <XStack className="min-w-0 items-center gap-1.5">
        <span className="truncate text-sm text-foreground">{person.name}</span>
        {person.isTeammate && <TeamLabel />}
      </XStack>
      {email && (
        <span className="truncate text-xs text-foreground-muted">{email}</span>
      )}
    </YStack>
  </XStack>
);
